import React, {Fragment} from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from "reactstrap";
import "./dropdownBox.sass";
import {KeyValue} from "../../../stores/observables/keyValue";
import {observer} from "mobx-react-lite";
import Icon from "../../atoms/common/icon/icon";
import {IconSource} from "../../../shared/enums/iconSource";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {ObservableList} from "../../../stores/observables/observableList";
import {runInAction} from "mobx";

export interface IDropdownBoxProps {
  placeholder?: string;
  icon?: IconSource;
  options: ObservableList<KeyValue>;
  onItemSelected: (item: KeyValue) => void;
}

const DropdownBox: React.FC<IDropdownBoxProps> = ({
  options,
  icon = IconSource.dropdown,
  onItemSelected,
  placeholder
}) => {
  const {t} = useTranslation("translation");

  const handleItemChange = (item: KeyValue) => {
    runInAction(() => {
      options.selectedItem = item;
    });
    onItemSelected?.(item);
  };

  return (
    <UncontrolledDropdown className="dropdown-box">
      <DropdownToggle role="button" data-testid="dropdownBox" tag="div">
        <span>
          {options.selectedItem?.label ??
            placeholder ??
            t("translation:dropdownDefaultPlaceholder")}
        </span>
        <Icon source={icon} />
      </DropdownToggle>
      <DropdownMenu right={true}>
        {options.items &&
          options.items.map((item) => {
            const isSameItem = item === options.selectedItem;
            return (
              <DropdownItem
                tag="div"
                key={item.value}
                item={item.value}
                className={classNames({selected: isSameItem})}
                onClick={() => {
                  if (!isSameItem) handleItemChange(item);
                }}
              >
                <Fragment>
                  <span>{item.label}</span>
                  {isSameItem && <Icon source={IconSource.successTick} />}
                </Fragment>
              </DropdownItem>
            );
          })}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default observer(DropdownBox);
